import { render, staticRenderFns } from "./todoListWidget.vue?vue&type=template&id=a4da46ae&scoped=true"
import script from "./todoListWidget.vue?vue&type=script&lang=js"
export * from "./todoListWidget.vue?vue&type=script&lang=js"
import style0 from "./todoListWidget.vue?vue&type=style&index=0&id=a4da46ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4da46ae",
  null
  
)

export default component.exports